import { ObjectSchema, object, string, number, mixed, boolean } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import {
    ElementCondition,
    Operator,
    elementConditionAndOper,
    elementConditionOrOper,
    elementConditionDefaultOper,
} from './../../models/element-condition';
yup.setLocale(locale);

export const elementConditionNameMaxLimit = 20;

export function elementConditionValidator(): ObjectSchema<ElementCondition> {
    return object({
        id: string().uuid().strict(),
        elementId: string().required().nonNullable().strict(),
        componentId: string().uuid().nonNullable().strict(),
        index: number().required().nonNullable().strict(),
        operator: mixed<Operator>()
            .oneOf([elementConditionAndOper, elementConditionOrOper, elementConditionDefaultOper])
            .required()
            .nonNullable()
            .strict(),
        name: string().required().nonNullable().strict().max(elementConditionNameMaxLimit),
    })
        .strict()
        .noUnknown();
}
